import React from 'react';
import emailjs from 'emailjs-com';

function Info() {

  const sendEmail = (e) => {
    e.preventDefault();

    const form = e.target;

    emailjs.sendForm(
    "service_34i0chi",
    "template_unyaefx",
    form,
    "l7MwKvcntcWgYMEcQ"
  )
  .then(() => {
    console.log("Notification sent to me");
  })
  .catch(() => {
    console.log("Notification failed");
  });

    emailjs.sendForm(
      'service_34i0chi',   // replace with your EmailJS service ID
      'template_mh6whye',  // replace with your EmailJS template ID
      e.target,
      'l7MwKvcntcWgYMEcQ'    // replace with your EmailJS public key
    )
    .then(() => {
      alert('Your message has been sent!');
    })
    .catch(() => {
      alert('Failed to send message. Please try again.');
    });

    e.target.reset();
  };

  return (
    <div className="sec-box contact section-padding bord-thin-top" id="info">
      <div className="row">
        <div className="col-lg-5">
          <div className="sec-head md-mb80 wow fadeIn">
            <h6 className="sub-title mb-15 opacity-7">Get In Touch</h6>
            <h2 className="fz-50">Turn Your Startup into Success Story!</h2>
            <p className="fz-15 mt-10">
              Whether you’re ready to start a project or just exploring ideas, drop a message — I’d be happy to talk things through.
            </p>
            <div className="phone fz-30 fw-600 mt-30 underline">
              <a href="tel:+923141553710" className="main-color">
                +92 336 9949123
              </a>
            </div>
            <div className="contact-info mt-30">
              <div className="email fz-30 fw-600 underline mb-20">
                <a href="mailto:haris@leadsnite.com" className="main-color">
                  Click To E-Mail
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-7 valign">
          <div className="full-width wow fadeIn">
            <form id="contact-form" onSubmit={sendEmail}>
              <div className="messages"></div>

              <div className="controls row">
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <input
                      id="form_name"
                      type="text"
                      name="name"
                      placeholder="Name"
                      required
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <input
                      id="form_email"
                      type="email"
                      name="email"
                      placeholder="Email"
                      required
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group mb-30">
                    <input
                      id="form_subject"
                      type="text"
                      name="subject"
                      placeholder="Subject"
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <textarea
                      id="form_message"
                      name="message"
                      placeholder="Message"
                      rows="4"
                      required
                    ></textarea>
                  </div>
                  <div className="mt-30">
                    <button type="submit">
                      <span className="text">Send A Message</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Info;
